/**
 * Permutes the elements of the array randomly, with an equal chance of receiving any permutation.
 *
 * @returns shuffled copy of the array
 */
export function shuffle<T>(value: T[]): T[] {
  const arr = [...value];
  // Straightforward Fisher-Yates shuffle
  for (let i = arr.length - 1; i > 0; i--) {
    const j = random(i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

/**
 * Returns a random integer in the interval [0, max).
 */
function random(max: number) {
  return Math.floor(Math.random() * max);
}
